import React, { useMemo } from 'react';
import { Button, Badge } from 'react-bootstrap';
import ProjectActionsCell from './ProjectActionsCell';

const useProjectColumns = ({ handleToggleStatus, handleEdit, handleDelete }) => {
    return useMemo(() => [
        { accessorKey: 'id', header: 'ID' },
        { accessorKey: 'project_name', header: 'Project Title' },
        { accessorKey: 'project_type', header: 'Type' },
        {
            accessorKey: 'status',
            header: 'Status',
            cell: info => {
                const status = info.getValue();
                const variant = status === 'Completed' ? 'success' : status === 'Casting' ? 'primary' : 'secondary';
                return <Badge bg={variant}>{status}</Badge>;
            }
        },
        { accessorKey: 'creator.full_name', header: 'Casting Director' },
        {
            id: 'toggle',
            header: 'Control',
            enableSorting: false,
            cell: (info) => {
                const status = info.row.original.status;
                return (
                    <Button
                        size="sm"
                        variant={status === 'active' ? 'success' : 'secondary'}
                        onClick={() => handleToggleStatus(info.row.original.id, info.row.original.status)}
                    >
                        {status === 'active' ? 'Deactivate' : 'Activate'}
                    </Button>
                );
            }
        },
        {
            id: 'actions',
            header: () => <div style={{ textAlign: 'center', width: '100%' }}>ACTIONS</div>,
            enableSorting: false,
            cell: (info) => (
                <ProjectActionsCell
                    projectId={info.row.original.id}
                    onEdit={handleEdit}
                    onDelete={handleDelete}
                />
            ),
        }
    ], [handleToggleStatus, handleEdit, handleDelete]);
};

export default useProjectColumns;
